module.exports = __webpack_public_path__ + "img/dots-bar.d72476cd.svg";